import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component'; 
import { HeaderComponent } from './components/blocks/allgemein/header/header.component';
import { FooterComponent } from './components/blocks/allgemein/footer/footer.component';
import { MainComponent } from './components/pages/anwendung/main/main.component';
import { MatSpinnerOverlayComponent } from './components/elemente/mat-spinner-overlay/mat-spinner-overlay.component';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UebersichtTabelleComponent } from './components/blocks/uebersicht-tabelle/uebersicht-tabelle.component';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';
import { FilterWertTabelleComponent } from './components/blocks/filter/filter-wert-tabelle/filter-wert-tabelle.component';
import { FilterAuspTabelleComponent } from './components/blocks/filter/filter-ausp-tabelle/filter-ausp-tabelle.component';
import { FilterAuspRowComponent } from './components/blocks/filter/filter-ausp-row/filter-ausp-row.component';
import { FilterWertRowComponent } from './components/blocks/filter/filter-wert-row/filter-wert-row.component';
import * as de from '@angular/common/locales/de';
import { ChartInvBedKbComponent } from './components/blocks/charts/chart-inv-bed-kb/chart-inv-bed-kb.component';
import { ChartInvBedKbJeMQuadratFktComponent } from './components/blocks/charts/chart-inv-bed-kb-je-m-quadrat-fkt/chart-inv-bed-kb-je-m-quadrat-fkt.component';
import { ChartInvBedNdComponent } from './components/blocks/charts/chart-inv-bed-nd/chart-inv-bed-nd.component';
import { ChartJaehrlicheGebeudeKostenComponent } from './components/blocks/charts/chart-jaehrliche-gebeude-kosten/chart-jaehrliche-gebeude-kosten.component';
import { ChartFbJeTpComponent } from './components/blocks/charts/chart-fb-je-tp/chart-fb-je-tp.component'; // Importiere die deutsche Locale
import { LightboxModule } from 'ngx-lightbox';
import { ModalYesNoDialogComponent } from './components/pages/anwendung/modal/modal-yes-no-dialog/modal-yes-no-dialog.component';
import { AuswahlComponent } from './components/pages/anwendung/auswahl/auswahl.component';
import { EinstellungenComponent } from './components/pages/anwendung/einstellungen/einstellungen.component';
import { UeberBaukostComponent } from './components/pages/navbar-pages/ueber-baukost/ueber-baukost.component';
import { BegriffserlaeuterungenBaukostComponent } from './components/pages/navbar-pages/begriffserlaeuterungen-baukost/begriffserlaeuterungen-baukost.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent, 
    FooterComponent,
    HilfeComponent,
    PageNotFoundComponent,
    MainComponent,
    MatSpinnerOverlayComponent,
    UebersichtTabelleComponent,
    ErgebnisseComponent,
    FilterWertTabelleComponent,
    FilterAuspTabelleComponent,
    FilterAuspRowComponent,
    FilterWertRowComponent,
    ChartInvBedKbComponent,
    ChartInvBedKbJeMQuadratFktComponent,
    ChartInvBedNdComponent,
    ChartJaehrlicheGebeudeKostenComponent,
    ChartFbJeTpComponent,
    ModalYesNoDialogComponent,
    AuswahlComponent,
    EinstellungenComponent,
    UeberBaukostComponent,
    BegriffserlaeuterungenBaukostComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    LightboxModule
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    registerLocaleData(de.default); // Registriere die deutsche Locale
  }
}

